import { Component } from '@angular/core';
import { ItemViewContainerBase } from '@fi-app/core/item-view-container-base';
import { RoleModel } from '../role.model';

@Component({
    selector: 'fi-role-view-container',
    template: '<fi-role-view [role]="role"></fi-role-view>',
    styleUrls: ['./role-view-container.component.scss'],
    standalone: false,
})
export class RoleViewContainerComponent extends ItemViewContainerBase {
    role: RoleModel;
}
